export default __webpack_public_path__ + "static/media/gold-volume.a5b8b551.png";